import * as Time$SolvuuClient0 from "solvuu-client0/./time.bs.js";

function now(param) {
  return Time$SolvuuClient0.of_span_since_epoch(Time$SolvuuClient0.Span.of_ms(Date.now()));
}

function toUTCString(x) {
  return new Date(Time$SolvuuClient0.Span.to_ms(Time$SolvuuClient0.to_span_since_epoch(x))).toUTCString();
}

var Span = Time$SolvuuClient0.Span;
var of_span_since_epoch = Time$SolvuuClient0.of_span_since_epoch;
var to_span_since_epoch = Time$SolvuuClient0.to_span_since_epoch;
var sub = Time$SolvuuClient0.sub;
var diff = Time$SolvuuClient0.diff;
export { Span, of_span_since_epoch, to_span_since_epoch, sub, diff, now, toUTCString };
/* No side effect */